import { FunctionComponent, useState, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { NAMESPACE_MAP } from '@ads-bread/shared/bread/util';
import { LinkToFAQs } from '../LinkToFAQs';
import { useNamespace } from '../../lib/hooks/useNamespace';
import { PageNames, useTrackPageView } from '../../lib/hooks/useTrackPageView';
import { useAppConfig } from '../AppConfigContext';
import { EcommFAQs } from './EcommFAQs';
import { InStoreFAQs } from './InStoreFAQs';

type Props = {
  onBack: () => void;
  className?: string;
};

export const FAQs: FunctionComponent<Props> = ({ onBack }) => {
  useTrackPageView({
    pageName: PageNames.FAQ,
  });
  const [isShowing, setIsShowing] = useState(true);
  const namespace = useNamespace();
  switch (namespace) {
    case NAMESPACE_MAP.InStore:
      return (
        <InStoreFAQs
          isShowing={isShowing}
          setIsShowing={setIsShowing}
          onBack={onBack}
        />
      );
    default:
      return (
        <EcommFAQs
          isShowing={isShowing}
          setIsShowing={setIsShowing}
          onBack={onBack}
        />
      );
  }
};

export const LearnMore: FunctionComponent = () => {
  const { faqUrl } = useAppConfig();
  return (
    <div className="pt-2 pb-9 text-sm">
      <p>
        <FormattedMessage
          defaultMessage="Learn more at <link>BreadPayments.com</link>"
          description="FAQ Screen FAQ link"
          values={{
            link: (chunks: ReactNode) => (
              <LinkToFAQs url={faqUrl} text={chunks} testID="external-faq" />
            ),
          }}
        />
      </p>
    </div>
  );
};
